import { FeeCollection } from "../api/request/Lead/Interfaces/DataInterface.response";

/**
 * Returns the next upcoming fee from a feeCollection array.
 * Picks the earliest fee whose expectedPaymentDate is today or later.
 * Falls back to the last entry when every date is in the past, or undefined when empty.
 */
export const getNextFee = (
  feeCollection?: FeeCollection[]
): FeeCollection | undefined => {
  if (!feeCollection || feeCollection.length === 0) return undefined;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const upcoming = feeCollection
    .filter((f) => new Date(f.expectedPaymentDate) >= today)
    .sort(
      (a, b) =>
        new Date(a.expectedPaymentDate).getTime() -
        new Date(b.expectedPaymentDate).getTime()
    );
  return upcoming[0] ?? feeCollection[feeCollection.length - 1];
};
